cobalt-toggle {
  display: flex;
}

cobalt-toggle .core-toggle .toggle-wrapper {
  padding: var(--number-spacing-none);
}
